import DepartmentModel from "./DepartmentModel";
import ProgramModel from "./ProgramModel";

export default class BillingCategoryModel {
  active?: boolean = true;
  department?: DepartmentModel;
  excludeFromReports?: boolean = false;
  id: string;
  // organizationId: number;
  program?: ProgramModel;
  title?: string = "";
  departmentId?: string | null = null;

  constructor(data: BillingCategoryModel | {}) {
    Object.assign(this, data);
  }
}
